__turbopack_context__.v({
  "bannerButton": "J_ojDG_bannerButton",
  "bannerImage": "J_ojDG_bannerImage",
  "bodyParagraph": "J_ojDG_bodyParagraph",
  "container": "J_ojDG_container",
  "contentWrapper": "J_ojDG_contentWrapper",
  "ctaWrapper": "J_ojDG_ctaWrapper",
  "heading": "J_ojDG_heading",
  "sand": "J_ojDG_sand",
});
